<template>
  <div class="my-10">
    <v-row align="center" justify="center">
      <v-list>
        <v-list-item 
          v-for="(item, index) in data"
          :key="index"
        >
          <feedback class="mt-2" :item="item" />
        </v-list-item>
      </v-list>
    </v-row>
    <v-row align="center" justify="center" v-if="enableEditor">
      <v-card width="800px" :outlined="true">
        <v-card-text>
          <editor
            :initialValue="feedbackDesc"
            :options="{ hideModeSwitch: true }"
            outlined
            ref="toastuiEditor"
            initialEditType="wysiwyg"
            @change="onEditorChange"
            label="Ficha del proyecto"
            :key="'feedbackEditor'+editorKey"
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-col cols="10" />
          <v-col cols="2">
            <v-btn
              color="success"
              @click.stop="postFeedback"              
            >
              Enviar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </div>
</template>
<script>
import { Editor } from '@toast-ui/vue-editor';
export default {
  props:{
    data:{
      type: Array,
      default: function(){ return [] }
    },
    id:{
      type:Number,
      default: undefined
    },
    status:{
      type:String,
      default:""
    },
    developer:{
      type:String,
      default:""
    }
  },
  components:{
    Feedback:()=>import('./Feedback.vue'),
    Editor
  },
  data(){
    return {
      editorKey: 0,
      feedbackDesc: "",

    }
  },
  computed:{
    enableEditor(){
      return (this.status==='Revision' && this.$store.getters.getUserRole === "admin") || (this.status==="Draft" && this.developer===this.$store.getters.oidcUser.name)
    }
  },
  methods:{
    onEditorChange() {
      this.feedbackDesc=this.$refs.toastuiEditor.invoke('getMarkdown');
    },
    postFeedback(){
      this.$cf_api.postProjectFeedback(this.id, {description:this.feedbackDesc}).then(()=>{
      })
    }
  }

}
</script>